import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faUserMinus } from '@fortawesome/free-solid-svg-icons';
import LoadingButton from '@shared/components/LoadingButton';
import AddUsersByGroup from '@modules/userGroups/componenets/AddUsersByGroup';
import { useUsersByGroupModal } from '@modules/users/hooks/useUsersByGroupModal';

export default function UsersByGroup({ onClose, groupId, groupName }) {
    const {
        showAddUsers,
        users,
        loading,
        saving,
        error,
        modalRef,
        usersToRemove,
        handleAddUsersClick,
        handleAddUsersClose,
        handleMainClose,
        handleRemoveUser,
        handleSave,
        t
    } = useUsersByGroupModal(onClose, groupId, groupName);

    if (loading) {
        return (
            <div className="modal show">
                <div className="form-wrapper top-20 width-50">
                    <div className="loading">{t('common.loading')}</div>
                </div>
            </div>
        );
    }

    if (showAddUsers) {
        return (
            <AddUsersByGroup
                onClose={handleAddUsersClose}
                groupId={groupId}
            />
        );
    }

    return (
        <div className="modal show" tabIndex="-1">
            <div className="form-wrapper top-20 width-50" ref={modalRef}>
                <form className="form">
                    <h2 className="title">{t('nav.administrator.adminSection.usersInGroup', { groupName })}</h2>
                    
                    {error && <div className="error-message">{error}</div>}
                    
                    <div className="form-controls">
                        <LoadingButton 
                            className="form-btn btn-blue"
                            onClick={handleAddUsersClick}
                            loading={saving}
                        >
                            <FontAwesomeIcon icon={faUserPlus} />
                            {t('common.add')}
                        </LoadingButton>
                    </div>

                    <div className="form-container">
                        <div className="form-data-container">
                            <div className="form-column">
                                <div className="form-input-wrapper">
                                    <div className="users-list">
                                        {users.length > 0 ? (
                                            users.map(user => (
                                                <div key={user.id} className="user-item">
                                                    <span>{user.username}</span>
                                                    <button
                                                    type="button"
                                                    className={`icon-button ${usersToRemove.includes(user.id) ? 'selected' : ''}`}
                                                    onClick={() => handleRemoveUser(user.id)}
                                                    title={t('common.remove')}
                                                >
                                                    <FontAwesomeIcon icon={faUserMinus} />
                                                </button>
                                            </div>
                                            ))
                                            ) : (
                                                <div className="no-users-message">
                                                {t('common.noUsersInGroup')}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-controls-container">
                        <button
                            type="button"
                            className="form-btn btn-blue"
                            onClick={handleSave}
                            disabled={saving}
                        >
                            {t('common.save')}
                        </button>
                        <button
                            type="button"
                            className="form-btn btn-red"
                            onClick={handleMainClose}
                        >
                            {t('common.cancel')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
} 